import page from "page";
import Clipboard from "clipboard";

(function() {
  "use strict";

  var Hexwalk = {
    init: function() {
      this.copyhex();

      this.tiles();

      this.checky();

      this.keyPresses();

      this.hexrouter();
    },

    hexrouter: function() {
      page("/", Hexwalk.ShowIndex);
      page("/:color", Hexwalk.ShowColor);

      page.start();
    },

    ShowIndex: function() {},

    ShowColor: function(clr) {
      if (clr.path) {
        var colorcode = clr.path.substring(1);

        // GA track event
        ga("send", "event", "Colors", "show", colorcode);

        if (document.querySelector(".closeup").style) {
          document.querySelector(".closeup").style.height = "600px";
          document.querySelector(".closeup").style.maxHeight = "600px";
          document.querySelector(
            ".closeup"
          ).style.backgroundColor = `#${colorcode}`;
          document.querySelector(".closeup h1").innerText = `#${colorcode}`;
          document
            .querySelector(".closeup__copy")
            .setAttribute("data-clipboard-text", `#${colorcode}`);
        } else {
          document.querySelector(
            ".closeup"
          ).style.backgroundColor = `#${colorcode}`;
          document.querySelector(".closeup h1").innerText = `#${colorcode}`;
          document
            .querySelector(".closeup__copy")
            .setAttribute("data-clipboard-text", `#${colorcode}`);
        }
      }
    },

    copyhex: function() {
      var clipboard = new Clipboard(".closeup__copy");

      clipboard.on("success", function(e) {
        document.querySelector(".closeup").classList.add("active");
        document.querySelector(".closeup h1").innerText = "Copied to Clipboard!";

        setTimeout(function() {
          document.querySelector(".closeup").style.height = "0px";
          document.querySelector(".closeup").style.maxHeight = "0px";
        }, 1200);

        e.clearSelection();
      });
    },

    keyPresses: function() {
      document.addEventListener("keyup", event => {
        if (event.keyCode == 27) {
          page("/");

          document.querySelector(".closeup").style.height = "0px";
          document.querySelector(".closeup").style.maxHeight = "0px";
        }
      });
    },

    checky: function() {
      document
        .querySelector(".closeup span")
        .addEventListener("click", function(event) {
          document.querySelector(".closeup").style.height = "0px";
          document.querySelector(".closeup").style.maxHeight = "0px";

          page("/");

          event.preventDefault();
        });

      document.addEventListener("click", function(e) {
        if (event.target.classList.contains("cell")) {
          var bgcolor = event.target.parentNode.parentNode.getAttribute(
            "data-color"
          );
          page("/" + bgcolor);
          Hexwalk.ShowColor(bgcolor);
        }
      });
    },

    tiles: function() {
      var i = 0;
      var delay = 2300;

      var tiles = document.querySelectorAll(".tile");

      for (let tile of tiles) {
        Hexwalk.randomize(tile);
      }

      var timerId = setInterval(function() {
        for (let tile of tiles) {
          Hexwalk.randomize(tile);
        }

        ++i;

        if (i > 2) {
          delay = 15000;
        }
      }, 8000);
    },

    randomize: function(elem) {
      var hexaletters = ["a", "b", "c", "d", "e", "f"];
      var tilesizes = [10, 40, 60, 600, 200];

      var tile = elem;

      var colors = Math.floor(Math.random() * 16777215).toString(16);

      const wiClass = new RegExp(/\btile---.+?\b/, "g");

      if (tile.className.match(wiClass)) {
        tile.className = mainIcon.className.replace(wiClass, "");
      }

      tile.classList.add(
        "tile--" + tilesizes[Math.floor(Math.random() * tilesizes.length)]
      );
      tile.style.backgroundColor = `#${colors}`;
      tile.setAttribute("data-color", colors);

      tile.querySelector(".table > .cell").innerText = `#${colors}`;

      setTimeout(function() {
        tile.querySelector(".table").classList.add("active");
      }, 2000);
    }
  };

  document.addEventListener("DOMContentLoaded", function() {
    Hexwalk.init();
  });
})();
